import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppConfig} from '../shared/app-config';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {Program} from '../model/program';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';
import {Product} from '../model/product';

const logger = factory.getLogger('OperatorProgramsService');

@Injectable({
  providedIn: 'root'
})
export class ProgramProductsService {

  private products: Observable<Product[]>;
  // private productsWithProgram: Observable<Product[]>;
  private productsLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  public findProducts(): Observable<Product[]> {
    if (this.products && !this.productsLastCallError) {
      logger.debug('findProducts: Cache hit.');
    } else {
      this.products = this.fetchProducts();
    }

    return this.products;
  }

  private fetchProducts(): Observable<Product[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlProducts).pipe(map(
      response => {
        const result = [];

        for (const product of response['data']) {
          if (product.hasOwnProperty('program_id')) {
            const displayLabel = product.display_label || '';

            result.push(Product.newInstance(product.id, product.program_id, displayLabel, product.status, product.timezone, product.timezone_short, product.timezone_long));
          } else {
            logger.warn(`Product program_id is missing. Ignoring product item from response ${product}`);
          }
        }

        logger.debug(`findProducts: ${result.length} products fetched from REST`);

        this.productsLastCallError = false;

        return result.sort((a: Product, b: Product) => a.displayLabel.localeCompare(b.displayLabel));
      }
      ), catchError((err: Error | HttpErrorResponse) => {
        const message = `In ProgramProductsService.findProducts().`;

        this.productsLastCallError = true;

        return throwError(ErrorDataService.overLoadError(err, message));
      }),
      publishReplay(1),
      refCount());
  }

  public getProductsWithProgram(products: Product[], programs: Program[]): Product[] {
    const result: Product[] = [];

    for (const product of products) {
      const program = programs.find(prg => prg.id === product.program.id);

      if (program) {
        product.program = program;

        result.push(product);
      }
    }

    return result;
  }

  /*public findProductsWithProgram(products: Program[]): Observable<Product[]> {
    if (this.products && !this.productsLastCallError && this.productsWithProgram) {
      logger.debug('findProductsWithProgram: Cache hit.');
    } else {
      this.productsWithProgram = this.fetchProductsWithProgram(products);
    }

    return this.productsWithProgram;
  }*/

  public findProductsWithProgram(programs: Program[]): Observable<Product[]> {
    return new Observable<Product[]>(subscriber => {
      let result: Product[];

      this.findProducts().subscribe(products => {
        result = this.getProductsWithProgram(products, programs);

        subscriber.next(result);
        subscriber.complete();
      });
    });
  }

  public sortProducts(products: Product[]): Product[] {
    return products.sort((a, b) => {
      let compResult = a.program.operator.displayLabel.localeCompare(b.program.operator.displayLabel);

      if (compResult === 0) {
        compResult = a.program.displayLabel.localeCompare(b.program.displayLabel);

        if (compResult === 0) {
          compResult = a.displayLabel.localeCompare(b.displayLabel);
        }
      }

      return compResult;
    });
  }
}
